import type { IntegrationEvent } from "../../shared/types";

export const mockEvents: IntegrationEvent[] = [
  {
    id: "event-acr-webhook-001",
    jobId: "job-acr-image-build",
    eventType: "ACR_WEBHOOK_PUSH",
    sourceType: "ACR",
    sourceName: "acrproddataops",
    status: "SUCCEEDED",
    severity: "MEDIUM",
    message: "ACR push webhook received for repository data-api.",
    rawPayloadPath: "/integration-monitor/raw/source=acr/year=2026/month=06/day=02/event-acr-webhook-001.json",
    occurredAt: "2026-06-02T09:25:10Z"
  },
  {
    id: "event-monitor-alert-001",
    jobId: "job-synapse-risk-long-running",
    eventType: "AZURE_MONITOR_ALERT",
    sourceType: "AZURE_MONITOR",
    sourceName: "am-prod-dataops",
    status: "LONG_RUNNING",
    severity: "CRITICAL",
    message: "Azure Monitor alert fired for risk scoring run duration.",
    rawPayloadPath: "/integration-monitor/raw/source=azure-monitor/year=2026/month=06/day=02/alert-risk-001.json",
    occurredAt: "2026-06-02T12:00:00Z"
  },
  {
    id: "event-synapse-failure-001",
    jobId: "job-synapse-finance-close",
    eventType: "SYNAPSE_PIPELINE_FAILURE",
    sourceType: "SYNAPSE",
    sourceName: "synw-prod-finance",
    status: "FAILED",
    severity: "CRITICAL",
    message: "Finance close pipeline failed on copy activity.",
    rawPayloadPath: "/integration-monitor/errors/source=synapse/year=2026/month=06/day=02/run-finance-019.json",
    occurredAt: "2026-06-02T07:16:00Z"
  }
];
